import { Grid, Typography } from '@mui/material';
import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';

import { getShippingDetails } from '../../services/shipping.service';
import { formatEventDate, formatTrackingAddress } from '../../utils';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';

export default function TrackDetailsView(props) {
    const [trackingData, setTrackingData] = useState();
    const [message, setMessage] = useState({});

    const getTrackingDetails = tracking_no => {
        getShippingDetails(tracking_no)
            .then(resp => {
                setTrackingData(resp);
            })
            .catch(error => {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            });
    };

    useEffect(() => {
        getTrackingDetails(props.tracking_no);
    }, [props.tracking_no]);

    return (
        <AppModal
            size="xl"
            show={props.showTrackingDetailsPopUp}
            onHide={() => props.setShowTrackingDetailsPopUp(false)}
            backdrop="static"
            modalTitle="Shipping Details">
            <Typography variant="subtitle1" mb={4} mt={2}>
                <span>USPS :&nbsp;&nbsp;&nbsp;</span>
                <a
                    href={`https://tools.usps.com/go/TrackConfirmAction?&tLabels=${props.tracking_no}`}
                    rel="noreferrer"
                    target="_blank">
                    {props.tracking_no}
                </a>
            </Typography>
            {!trackingData && (
                <Box position="absolute" top="50%" left="50%">
                    <span className="spinner-border spinner-border-md"></span>
                </Box>
            )}
            {message && <MessageContainer message={message} />}
            {trackingData && (
                <Divider style={{ background: '#707070', height: 2 }} />
            )}
            {trackingData?.map(data => {
                return (
                    <>
                        <Grid
                            container
                            style={{
                                backgroundColor: '#ffffff',
                                marginTop: '20px',
                                marginBottom: '20px',
                            }}>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                alignItems="flex-start">
                                <Typography variant="subtitle1">
                                    <b>
                                        {formatEventDate(
                                            data.eventTimestamp,
                                            true,
                                        )}
                                    </b>
                                </Typography>
                                <Typography variant="subtitle2">
                                    {formatEventDate(
                                        data.eventTimestamp,
                                        false,
                                    )}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                alignItems="flex-start">
                                <Typography variant="subtitle1">
                                    {data.eventType}
                                </Typography>
                                <Typography variant="subtitle2">
                                    {formatTrackingAddress(
                                        data.eventCity,
                                        data.eventState,
                                        data.eventZIPCode,
                                    )}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ background: '#707070', height: 2 }} />
                    </>
                );
            })}
            <Button
                variant="contained"
                className="float-end"
                style={{ margin: '15px 15px 0px 15px' }}
                onClick={() => {
                    props.setShowTrackingDetailsPopUp(false);
                }}>
                Close
            </Button>
        </AppModal>
    );
}
